// Placeholder logo — replace SVG paths when real brand files are provided
import React from 'react'
import { cn } from '@/lib/utils'

interface LogoProps {
  variant?: 'full' | 'icon'
  className?: string
}

export function Logo({ variant = 'full', className }: LogoProps) {
  if (variant === 'icon') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width={32}
        height={32}
        className={cn('shrink-0', className)}
        aria-label="SOS Tunisie icon"
      >
        <rect width="32" height="32" rx="6" className="fill-primary" />
        <text
          x="16"
          y="22"
          textAnchor="middle"
          fontSize="11"
          fontWeight="bold"
          fontFamily="system-ui, sans-serif"
          fill="white"
        >
          SOS
        </text>
      </svg>
    )
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 140 32"
      width={140}
      height={32}
      className={cn('shrink-0', className)}
      aria-label="SOS Tunisie logo"
    >
      {/* Icon badge */}
      <rect width="32" height="32" rx="6" className="fill-primary" />
      <text
        x="16"
        y="22"
        textAnchor="middle"
        fontSize="11"
        fontWeight="bold"
        fontFamily="system-ui, sans-serif"
        fill="white"
      >
        SOS
      </text>
      {/* Brand name */}
      <text
        x="40"
        y="21"
        fontSize="13"
        fontWeight="600"
        fontFamily="system-ui, sans-serif"
        className="fill-foreground"
      >
        Tunisie
      </text>
    </svg>
  )
}
